import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentServicesRequest } from "../../../../../redux/inspection-firms/slice";
import { Card, Box, Typography, Divider, Button } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Loading from "../../../../../components/loading/loading";
import "./services.css";
import EditServices from "../../../inspection-firms/inspection-firm-details/services/edit-services/edit-services";

const Services = () => {
  const dispatch = useDispatch();
  const [showEditServices, setShowEditServices] = useState(false);

  useEffect(() => {
    dispatch(getCurrentServicesRequest());
  }, [dispatch]);

  const { loading, currentServices } = useSelector(
    (state: any) => state.inspectionFirms
  );

  const handleEditServices = () => {
    setShowEditServices(true);
  };

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Services Offered</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditServices}
          >
            Edit
          </Button>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">Agency Inspections</Typography>
          <Box>
            {currentServices?.agencyInspections?.length > 0
              ? currentServices?.agencyInspections?.map((inspection: any) => (
                  <Typography>{inspection?.displayName}</Typography>
                ))
              : "-"}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Commercial Property <br />
            Inspections
          </Typography>
          <Box>
            {currentServices?.commercialInspections?.length > 0
              ? currentServices?.commercialInspections?.map((inspection: any) => (
                  <Typography>{inspection?.displayName}</Typography>
                ))
              : "-"}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Residential Property <br />
            Inspections
          </Typography>
          <Box>
            {currentServices?.residentialInspections?.length > 0
              ? currentServices?.residentialInspections?.map((inspection: any) => (
                  <Typography>{inspection?.displayName}</Typography>
                ))
              : "-"}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Specialty Inspections
          </Typography>
          <Box>
            {currentServices?.specialtyInspections?.length > 0
              ? currentServices?.specialtyInspections?.map((inspection: any) => (
                  <Typography>{inspection?.displayName}</Typography>
                ))
              : "-"}
          </Box>
        </Box>
        <Typography
          sx={{
            color: "rgba(0, 0, 0, 0.6) !important",
            mt: 2,
            fontStyle: "italic",
            fontSize: "14px",
          }}
        >
          *In order to receive these types of inspections, at least 1 certified
          inspector must be active in your firm.
        </Typography>
      </Card>
      {loading && <Loading />}
      {showEditServices && (
        <EditServices
          showDialog={showEditServices}
          closeDialog={() => {
            setShowEditServices(false);
          }}
          data={{ ...currentServices }}
        />
      )}
    </>
  );
};

export default Services;
